import { useNavigate } from "react-router-dom";
import { useAccount } from "../account/context";
import { MegaMenu } from "../shared/mega-menu";
import { useClinicalAccount } from "../account/clinical-context";

export interface INavItem {
  text: string;
  path: string;
}

export const Header = () => {
  const { isLoggedIn, doLogout } = useAccount();
  const { isClinician, doClinicianLogout } = useClinicalAccount();

  const navigate = useNavigate();

  return (
    <header>
      <div className="constrained">
        <a
          href="/"
          className="logo"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          <h1>Kidney failure</h1>
          <p>Making a plan that works for you</p>
        </a>
        <nav>
          <ul>
            <li>
              <a
                href="#"
                className={
                  document.location.pathname.indexOf("/treatment-options/") > -1
                    ? "selected"
                    : ""
                }
              >
                Treatment Options
              </a>
              <MegaMenu />
            </li>
            <li>
              <a
                className={
                  document.location.pathname === "/planning" ? "selected" : ""
                }
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/planning");
                }}
                href="planning"
              >
                Planning
              </a>
            </li>
            <li className="tools">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/tools/virtual-arm");
                }}
                href="/tools/virtual-arm"
              >
                Tools
              </a>
              {
                <div className="submenu account" style={SubmenuStyles}>
                  <div className="column">
                    <ul>
                      {isClinician && (
                        <li>
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(
                                "/account/clinical/questionnaire-analytics"
                              );
                            }}
                            href="/account/clinical/questionnaire-analytics"
                          >
                            Questionnaire Analytics
                          </a>
                        </li>
                      )}
                      <li>
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/tools/virtual-arm");
                          }}
                          href="/tools/virtual-arm"
                        >
                          Virtual Arm
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/forms/vascular-access-quality-of-life");
                          }}
                          href="/forms/vascular-access-quality-of-life"
                        >
                          Your quality of life
                        </a>
                      </li>

                      <li>
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/other-questionnaires");
                          }}
                          href="/other-questionnaires"
                        >
                          Other questionnaires
                        </a>
                      </li>

                      {(isLoggedIn || isClinician) && (
                        <li>
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              doLogout();
                              if (isClinician) {
                                doClinicianLogout();
                              }
                            }}
                            href="#"
                          >
                            Logout
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              }
            </li>
            <li className="favourites">
              <a
                href="/favourites"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/account/favourites");
                }}
              >
                Favourites
              </a>
            </li>
            <li className="account">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/account/profile");
                }}
                href="/account/profile"
              >
                Account
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

const SubmenuStyles = {
  background: "#fff",
  padding: "16px 24px",
};
// <Navigation />
